import { type ComponentPropsWithoutRef, type ReactNode } from "react";
import fieldStyles from "./Field.module.css";
import styles from "./Form.module.css";
import { Label } from "./Label";

const FormActions = ({ children }: { children: ReactNode }) => <div className={styles["formActions"]}>{children}</div>;

const FormFeedback = ({ type, children }: { type: "error" | "success"; children: ReactNode }) => (
  <p className={styles[type === "error" ? "errorText" : "successText"]}>{children}</p>
);

export const Form = ({ children, ...props }: ComponentPropsWithoutRef<"form">) => (
  <form className={styles["form"]} {...props}>
    {children}
  </form>
);

const FormField = ({
  label,
  info,
  infoTitle,
  children,
}: {
  label: string;
  info?: ReactNode;
  infoTitle?: string;
  children: ReactNode;
}) => (
  <div className={fieldStyles["field"]}>
    <Label info={info} infoTitle={infoTitle}>
      {label}
    </Label>
    {children}
  </div>
);

Form.Actions = FormActions;
Form.Feedback = FormFeedback;
Form.Field = FormField;
